import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { COLOR_SWATCHES } from "constants/action-types";
import { ISwatch } from "constants/color-swatches";
import {
    fetchActions,
    IFetchStoreState,
    progressActions,
    updateStateActions,
    IBaseStoreState,
    initialFetchState,
    updateActions,
} from "./base-reducers";

export interface IColorSwatchesState {
    list: IColorSwatches;
    export: IExportState;
    import: IImportState;
}

export interface IUploadState {
    swatches: ISwatch[];
    errorList: string[];
}

export interface IDownloadState {
    url: string;
}

interface IColorSwatches extends IFetchStoreState<ISwatch[]> {
    isSetting: boolean;
}

interface IExportState extends IBaseStoreState<IDownloadState> {
    isExporting: boolean;
}

interface IImportState extends IBaseStoreState<IUploadState> {
    isUploading: boolean;
}

export const colorSwatches = combineReducers<IColorSwatchesState>({
    list: handleActions<IColorSwatches>(
        {
            ...fetchActions<ISwatch[]>(COLOR_SWATCHES.LIST.FETCH),
            ...updateActions<IColorSwatches>(COLOR_SWATCHES.LIST),
            ...progressActions<ISwatch[], IColorSwatches>(COLOR_SWATCHES.LIST.SET, "isSetting"),
        } as any,
        {
            ...initialFetchState,
            isSetting: false,
        },
    ),
    import: handleActions<IImportState>(
        {
            ...updateStateActions<IImportState>(COLOR_SWATCHES.IMPORT),
            ...progressActions<IUploadState, IImportState>(COLOR_SWATCHES.IMPORT.UPLOAD, "isUploading"),
        } as any,
        {
            payload: null,
            isUploading: false,
        },
    ),
    export: handleActions<IExportState>(
        {
            ...updateStateActions<IExportState>(COLOR_SWATCHES.EXPORT),
            ...progressActions<IDownloadState, IExportState>(COLOR_SWATCHES.EXPORT.DOWNLOAD, "isExporting"),
        } as any,
        {
            payload: null,
            isExporting: false,
        },
    ),
});
